import { parseNumberInput } from "@/lib/parse-number";

export interface PlaceFieldValues {
  /** A preset id from `PLACES`, or "custom". */
  place: string;
  latitude: string;
  longitude: string;
  zone: string;
}

export type PlaceReading =
  | { ok: true; latitude: number; longitude: number }
  | { ok: false; error: "latitude" | "longitude" };

/** Read the latitude and longitude boxes; the error names the first box that is wrong. */
export function readPlace(values: PlaceFieldValues): PlaceReading {
  const latitude = parseNumberInput(values.latitude);
  if (latitude === null || latitude < -90 || latitude > 90) {
    return { ok: false, error: "latitude" };
  }
  const longitude = parseNumberInput(values.longitude);
  if (longitude === null || longitude < -180 || longitude > 180) {
    return { ok: false, error: "longitude" };
  }
  return { ok: true, latitude, longitude };
}

/** A latitude or longitude written for the boxes: four decimals, no trailing zeros. */
export function coordinateText(value: number): string {
  return String(Math.round(value * 10_000) / 10_000);
}
